import React from "react";

import ArrowRightIcon from "../../../../public/svg/ButtonIcons/right-arrow.svg";
import AuthorizationsIcon from "../../../../public/svg/SideBarIcons/autorizaciones.svg";
import MonthlyReportsIcon from "../../../../public/svg/SideBarIcons/estadosMensuales.svg";
import GreenDotIcon from "../../../../public/svg/SideBarIcons/green-dot.svg";
import HistoryIcon from "../../../../public/svg/SideBarIcons/historico.svg";
import FutureCashFlowIcon from "../../../../public/svg/SideBarIcons/ingresosFuturos.svg";
import InvestIcon from "../../../../public/svg/SideBarIcons/invertir.svg";
import HomeIcon from "../../../../public/svg/SideBarIcons/logo-home.svg";
import OrdersIcon from "../../../../public/svg/SideBarIcons/ordenes.svg";
import PhoneIcon from "../../../../public/svg/SideBarIcons/phone.svg";
import PortfolioIcon from "../../../../public/svg/SideBarIcons/portafolio.svg";
import UserIcon from "../../../../public/svg/SideBarIcons/user.svg";
import AddIcon from "../../../../public/svg/add.svg";
import ReturnedIcon from "../../../../public/svg/assignment_returned.svg";
import CalendarIcon from "../../../../public/svg/calendar.svg";
import TravelIcon from "../../../../public/svg/card_travel.svg";
import CSVIcon from "../../../../public/svg/csv.svg";
import DashboardIcon from "../../../../public/svg/dashboard.svg";
import DocumentationIcon from "../../../../public/svg/documentacion.svg";
import DownloadIcon from "../../../../public/svg/download-svgrepo-com.svg";
import HelpIcon from "../../../../public/svg/help.svg";
import InformationIcon from "../../../../public/svg/i.svg";
import ArrowDownIcon from "../../../../public/svg/keyboard_arrow_down.svg";
import LockIcon from "../../../../public/svg/lock.svg";
import LogoutIcon from "../../../../public/svg/logout.svg";
import SearchIcon from "../../../../public/svg/magnifying-glass-svgrepo-com.svg";
import MenuIcon from "../../../../public/svg/menu.svg";
import NotificationIcon from "../../../../public/svg/notificaciones.svg";
import PDFIcon from "../../../../public/svg/pdf.svg";
import PrintIcon from "../../../../public/svg/print-solid.svg";
import CloseIcon from "../../../../public/svg/x-symbol-svgrepo-com.svg";
import XLSXIcon from "../../../../public/svg/xlsx.svg";
import ProfileIcon from "../../../../public/svg/profile.svg";
import CloseSessionIcon from "../../../../public/svg/closeSession.svg";
import RadioCheckedIcon from "../../../../public/svg/ButtonIcons/radio-checked.svg";
import RadioUncheckedIcon from "../../../../public/svg/ButtonIcons/radio-unchecked.svg";
import RadioCheckedBlackIcon from "../../../../public/svg/ButtonIcons/radio-checked-black.svg";
import RadioUncheckedBlackIcon from "../../../../public/svg/ButtonIcons/radio-unchecked-black.svg";
import USD from "../../../../public/svg/Currencies/usd.svg";
import PYG from "../../../../public/svg/Currencies/pyg.svg";
import ArrowLeftIcon from "../../../../public/svg/ButtonIcons/left-arrow.svg";
import DocumentIcon from "../../../../public/svg/ButtonIcons/doc.svg";
import FileIcon from "../../../../public/svg/file.svg";
import CheckedContractIcon from "../../../../public/svg/checkboxContract.svg";
import RadioCheckedAccount from "../../../../public/svg/radioCheckAccount.svg";
import RadioUncheckedAccount from "../../../../public/svg/radioUncheckAccount.svg";
import RadioCheckedAnswer from "../../../../public/svg/radioCheckedAnswer.svg";
import WelcomeTick from "../../../../public/svg/welcomeTick.svg";
import GreenFaceIcon from "../../../../public/svg/greenFace.svg";
import GreenStarIcon from "../../../../public/svg/greenStar.svg";
import UncheckedMenu from "../../../../public/svg/SideBarIcons/uncheckedMenu.svg";
import CheckedMenu from "../../../../public/svg/SideBarIcons/checkedMenu.svg";
import GreenCircle from "../../../../public/svg/SideBarIcons/greenCircle.svg";
import PencilInput from "../../../../public/svg/pencil.svg";
import InformationLoginIcon from "../../../../public/svg/LoginInIcons/info.svg";
import EngineIcon from "../../../../public/svg/LoginInIcons/engine.svg";
import PersonIcon from "../../../../public/svg/LoginInIcons/person.svg";
import HomeIconWhite from "../../../../public/svg/SideBarIcons/logo-home-white.svg";
import CheckInfo from "../../../../public/svg/checkInfo.svg";
import Close from "../../../../public/svg/ButtonIcons/close.svg";
import InfoIcon from "../../../../public/svg/information.svg";
import ErrorIcon from "../../../../public/svg/error.svg";
import SuccessIcon from "../../../../public/svg/success.svg";
import WarningIcon from "../../../../public/svg/warning.svg";
import CheckboxCheckedIcon from "../../../../public/svg/checkbox-checked.svg";
import CheckboxUncheckedIcon from "../../../../public/svg/checkbox-unchecked.svg";

import { sizes } from "../../../utils/dimentions";

export const Icon = ({ src, size = sizes.md, ...otherProps }) => {
  return <img src={src} style={{ width: sizes[size], height: sizes[size] }} {...otherProps} />;
};

export const Icons = {
  ArrowRightIcon: (props) => <Icon src={ArrowRightIcon} {...props} />,
  ArrowLeftIcon: (props) => <Icon src={ArrowLeftIcon} {...props} />,
  AuthorizationsIcon: (props) => <Icon src={AuthorizationsIcon} {...props} />,
  MonthlyReportsIcon: (props) => <Icon src={MonthlyReportsIcon} {...props} />,
  GreenDotIcon: (props) => <Icon src={GreenDotIcon} {...props} />,
  HistoryIcon: (props) => <Icon src={HistoryIcon} {...props} />,
  FutureCashFlowIcon: (props) => <Icon src={FutureCashFlowIcon} {...props} />,
  InvestIcon: (props) => <Icon src={InvestIcon} {...props} />,
  HomeIcon: (props) => <Icon src={HomeIcon} {...props} />,
  OrdersIcon: (props) => <Icon src={OrdersIcon} {...props} />,
  PhoneIcon: (props) => <Icon src={PhoneIcon} {...props} />,
  PortfolioIcon: (props) => <Icon src={PortfolioIcon} {...props} />,
  UserIcon: (props) => <Icon src={UserIcon} {...props} />,
  AddIcon: (props) => <Icon src={AddIcon} {...props} {...props} />,
  ReturnedIcon: (props) => <Icon src={ReturnedIcon} {...props} />,
  CalendarIcon: (props) => <Icon src={CalendarIcon} {...props} />,
  TravelIcon: (props) => <Icon src={TravelIcon} {...props} />,
  CSVIcon: (props) => <Icon src={CSVIcon} {...props} />,
  DashboardIcon: (props) => <Icon src={DashboardIcon} {...props} />,
  DocumentationIcon: (props) => <Icon src={DocumentationIcon} {...props} />,
  DocumentIcon: (props) => <Icon src={DocumentIcon} {...props} />,
  DownloadIcon: (props) => <Icon src={DownloadIcon} {...props} />,
  HelpIcon: (props) => <Icon src={HelpIcon} {...props} />,
  InformationIcon: (props) => <Icon src={InformationIcon} {...props} />,
  ArrowDownIcon: (props) => <Icon src={ArrowDownIcon} {...props} />,
  LockIcon: (props) => <Icon src={LockIcon} {...props} />,
  LogoutIcon: (props) => <Icon src={LogoutIcon} {...props} />,
  SearchIcon: (props) => <Icon src={SearchIcon} {...props} />,
  MenuIcon: (props) => <Icon src={MenuIcon} {...props} />,
  NotificationIcon: (props) => <Icon src={NotificationIcon} {...props} />,
  PDFIcon: (props) => <Icon src={PDFIcon} {...props} />,
  PrintIcon: (props) => <Icon src={PrintIcon} {...props} />,
  CloseIcon: (props) => <Icon src={CloseIcon} {...props} />,
  XLSXIcon: (props) => <Icon src={XLSXIcon} {...props} />,
  ProfileIcon: (props) => <Icon src={ProfileIcon} {...props} />,
  CloseSessionIcon: (props) => <Icon src={CloseSessionIcon} {...props} />,
  RadioCheckedIcon: (props) => <Icon src={RadioCheckedIcon} {...props} />,
  RadioUncheckedIcon: (props) => <Icon src={RadioUncheckedIcon} {...props} />,
  RadioCheckedBlackIcon: (props) => <Icon src={RadioCheckedBlackIcon} {...props} />,
  RadioUncheckedBlackIcon: (props) => <Icon src={RadioUncheckedBlackIcon} {...props} />,
  USDIcon: (props) => <Icon src={USD} {...props} />,
  PYGIcon: (props) => <Icon src={PYG} {...props} />,
  FileIcon: (props) => <Icon src={FileIcon} {...props} />,
  CheckedContractIcon: (props) => <Icon src={CheckedContractIcon} {...props} />,
  RadioCheckedAccount: (props) => <Icon src={RadioCheckedAccount} {...props} />,
  RadioUncheckedAccount: (props) => <Icon src={RadioUncheckedAccount} {...props} />,
  RadioCheckedAnswer: (props) => <Icon src={RadioCheckedAnswer} {...props} />,
  WelcomeTick: (props) => <Icon src={WelcomeTick} {...props} />,
  GreenFaceIcon: (props) => <Icon src={GreenFaceIcon} {...props} />,
  GreenStarIcon: (props) => <Icon src={GreenStarIcon} {...props} />,
  UncheckedMenu: (props) => <Icon src={UncheckedMenu} {...props} />,
  CheckedMenu: (props) => <Icon src={CheckedMenu} {...props} />,
  GreenCircle: (props) => <Icon src={GreenCircle} {...props} />,
  PencilInput: (props) => <Icon src={PencilInput} {...props} />,
  InformationLoginIcon: (props) => <Icon src={InformationLoginIcon} {...props} />,
  EngineIcon: (props) => <Icon src={EngineIcon} {...props} />,
  PersonIcon: (props) => <Icon src={PersonIcon} {...props} />,
  HomeIconWhite: (props) => <Icon src={HomeIconWhite} {...props} />,
  CheckInfo: (props) => <Icon src={CheckInfo} {...props} />,
  Close: (props) => <Icon src={Close} {...props} />,
  InfoIcon: (props) => <Icon src={InfoIcon} {...props} />,
  ErrorIcon: (props) => <Icon src={ErrorIcon} {...props} />,
  SuccessIcon: (props) => <Icon src={SuccessIcon} {...props} />,
  WarningIcon: (props) => <Icon src={WarningIcon} {...props} />,
  CheckboxCheckedIcon: (props) => <Icon src={CheckboxCheckedIcon} {...props} />,
  CheckboxUncheckedIcon: (props) => <Icon src={CheckboxUncheckedIcon} {...props} />,
};
